import { fbprintpdf } from "@project/components/printJSFunctions"
import { getAxiosCancelToken, getCatchErrorMessage, isblank, setAxiosCancelToken } from "@project/sharedcomponents/utilityFunctions"
import axios from "axios"
import { getAccountSitesetting, getheaders, handleResponse, postErrorOnException } from "../Lib/commonfunctions"

import { list_url } from "@project/sharedcomponents/apiURL"
import { ChequePrint } from "../Lib/printFunctions"
import {
  CHEQUE_PRINTING_SEARCH_TEXT_UPDATE,
  CHEQUE_PRINTING_SERVICE_CLEAR,
  CHEQUE_PRINTING_SERVICE_FAIL,
  CHEQUE_PRINTING_SERVICE_START,
  CHEQUE_PRINTING_SERVICE_SUCCESS,
  FORM_DEP_SERVICE_SUCCESS,
  LOADING_STATE,
  SNACKBAR_STATE,
} from "./types"

export const chequePrinting_data_clear = () => {
  return (dispatch) => {
    dispatch({
      type: CHEQUE_PRINTING_SERVICE_CLEAR,
    })
  }
}
export const chequePrintingsearch_change = ({ search_text }) => {
  return (dispatch) => {
    dispatch({
      type: CHEQUE_PRINTING_SEARCH_TEXT_UPDATE,
      search_text: search_text,
    })
  }
}
export const fetch_chequePrinting_data = ({ rowsPerPage, page, order, orderBy, search_text, functions }) => {
  if (isblank(rowsPerPage)) {
    rowsPerPage = getAccountSitesetting("pagination_size")
  }
  return (dispatch) => {
    if (typeof getAxiosCancelToken() != typeof undefined) {
      getAxiosCancelToken().cancel("Operation canceled due to new request.")
    }
    // save the new request for cancellation
    setAxiosCancelToken(axios.CancelToken.source())
    dispatch({ type: CHEQUE_PRINTING_SERVICE_START })
    dispatch({ type: LOADING_STATE, state: true })
    let data = new FormData()
    if (rowsPerPage === "All") {
      data.append("offset", 0)
    } else {
      data.append("offset", page * rowsPerPage)
    }
    data.append("type", "chequePrinting")
    data.append("limit", rowsPerPage)
    data.append("sort_order", order)
    data.append("sort_by", orderBy)
    data.append("search_text", search_text)
    axios.defaults.headers.common = getheaders()
    axios({
      method: "post",
      url: list_url({ type: "chequePrinting" }),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },

      data: data,
      cancelToken: getAxiosCancelToken().token,
    })
      .then((response) => handleResponse(response, dispatch))
      .then((response) => {
        if (response.data.meta.code === 401) {
          chequePrintingServiceFail({ dispatch, response: response.data.meta.message, rowsPerPage, page, order, orderBy, search_text })
          dispatch({ type: LOADING_STATE, state: false })
        } else {
          if (rowsPerPage === "All") {
            dispatch({ type: FORM_DEP_SERVICE_SUCCESS, payload: { data: { dd_cheque_template: response.data.result } } })
          } else {
            chequePrintingServiceSuccess({ dispatch, user: response, rowsPerPage, page, order, orderBy, search_text })
          }
          dispatch({ type: LOADING_STATE, state: false })
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          dispatch({ type: LOADING_STATE, state: false })
        } else {
          postErrorOnException(error)
          chequePrintingServiceFail({ dispatch, response: getCatchErrorMessage(error), rowsPerPage, page, order, orderBy, search_text })
          dispatch({ type: LOADING_STATE, state: false })
        }
      })
  }
}

const chequePrintingServiceSuccess = ({ dispatch, user, rowsPerPage, page, order, orderBy, search_text }) => {
  dispatch({
    type: CHEQUE_PRINTING_SERVICE_SUCCESS,
    payload: user,
    rowsPerPage: rowsPerPage,
    page: page,
    order: order,
    orderBy: orderBy,
    search_text: search_text,
  })
}

const chequePrintingServiceFail = ({ dispatch, response, rowsPerPage, page, order, orderBy, search_text }) => {
  dispatch({
    type: SNACKBAR_STATE,
    payload: true,
    message: response,
    snackbarType: "error",
  })

  dispatch({
    type: CHEQUE_PRINTING_SERVICE_FAIL,
    payload: response,
    rowsPerPage: rowsPerPage,
    page: page,
    order: order,
    orderBy: orderBy,
    search_text: search_text,
  })
}

export const Cheque_Print = ({ paymentDetail, chequeDetail }) => {
  return (dispatch) => {
    var dd = ChequePrint({ paymentDetail, chequeDetail })
    const metadata = {
      filename: `Cheque_of_${paymentDetail.name}`,
    }
    fbprintpdf({ docDefinition: dd, metadata, action: "print" })
  }
}
